module.exports = {
    config: require('./config'),
    procedures: {
        source_create: {
            definition: require('./source_create/definition.json'),
            mock_data: require('./source_create/mock_data.json')
        },
        source_read: {
            definition: require('./source_read/definition.json'),
            mock_data: require('./source_read/mock_data.json')
        },
        source_update: {
            definition: require('./source_update/definition.json'),
            mock_data: require('./source_update/mock_data.json')
        },
        source_list: {
            definition: require('./source_list/definition.json'),
            mock_data: require('./source_list/mock_data.json')
        },
        source_reference_create: {
            definition: require('./source_reference_create/definition.json'),
            mock_data: require('./source_reference_create/mock_data.json')
        },
        source_reference_read: {
            definition: require('./source_reference_read/definition.json'),
            mock_data: require('./source_reference_read/mock_data.json')
        },
        source_reference_update: {
            definition: require('./source_reference_update/definition.json'),
            mock_data: require('./source_reference_update/mock_data.json')
        },
        source_reference_list: {
            definition: require('./source_reference_list/definition.json'),
            mock_data: require('./source_reference_list/mock_data.json')
        },
        concept_create: {
            definition: require('./concept_create/definition.json'),
            mock_data: require('./concept_create/mock_data.json')
        },
        concept_list: {
            definition: require('./concept_list/definition.json'),
            mock_data: require('./concept_list/mock_data.json')
        },
        concept_read: {
            definition: require('./concept_read/definition.json'),
            mock_data: require('./concept_read/mock_data.json')
        },
        concept_update: {
            definition: require('./concept_update/definition.json'),
            mock_data: require('./concept_update/mock_data.json')
        },
        course_create: {
            definition: require('./course_create/definition.json'),
            mock_data: require('./course_create/mock_data.json')
        },
        course_list: {
            definition: require('./course_list/definition.json'),
            mock_data: require('./course_list/mock_data.json')
        },
        course_read: {
            definition: require('./course_read/definition.json'),
            mock_data: require('./course_read/mock_data.json')
        },
        course_section_create: {
            definition: require('./course_section_create/definition.json'),
            mock_data: require('./course_section_create/mock_data.json')
        },
        course_section_update: {
            definition: require('./course_section_update/definition.json'),
            mock_data: require('./course_section_update/mock_data.json')
        },
        course_update: {
            definition: require('./course_update/definition.json'),
            mock_data: require('./course_update/mock_data.json')
        },
        lesson_create: {
            definition: require('./lesson_create/definition.json'),
            mock_data: require('./lesson_create/mock_data.json')
        },
        lesson_list: {
            definition: require('./lesson_list/definition.json'),
            mock_data: require('./lesson_list/mock_data.json')
        },
        lesson_read: {
            definition: require('./lesson_read/definition.json'),
            mock_data: require('./lesson_read/mock_data.json')
        },
        lesson_update: {
            definition: require('./lesson_update/definition.json'),
            mock_data: require('./lesson_update/mock_data.json')
        },
        user_concept_list: {
            definition: require('./user_concept_list/definition.json'),
            mock_data: require('./user_concept_list/mock_data.json')
        },
        user_concept_create: {
            definition: require('./user_concept_create/definition.json'),
            mock_data: require('./user_concept_create/mock_data.json')
        },
        user_concept_read: {
            definition: require('./user_concept_read/definition.json'),
            mock_data: require('./user_concept_read/mock_data.json')
        },
        user_concept_update: {
            definition: require('./user_concept_update/definition.json'),
            mock_data: require('./user_concept_update/mock_data.json')
        },
        user_course_list: {
            definition: require('./user_course_list/definition.json'),
            mock_data: require('./user_course_list/mock_data.json')
        },
        user_lesson_list: {
            definition: require('./user_lesson_list/definition.json'),
            mock_data: require('./user_lesson_list/mock_data.json')
        }
    }
};
